import React, { useState } from 'react'
import { Wrapper, BarStrip, ProgressBar, ModalComponent, SelectFieldIcon, TextFieldIcon, TextField } from '../_components'
import Table, { SelectColumnFilter } from '../_components/Table'
import data from '../fixtures'
import Axios from 'axios'
import moment from 'moment'
import { useSelector, useDispatch } from 'react-redux'
import { setAuditModal } from '../_slices/AppSlice'
import { Formik } from 'formik' 

const ActionField = ( record ) => {
  const dispatch = useDispatch()

  return (
    ( parseInt( record.row.original?.stage ) === 4 && record.row.original?.scheduled_action === "PENDING" && localStorage.getItem( "role" ) === "APPLICANT" ) && 
      ( <div onClick={async () => {
      let payload = JSON.stringify( record.row.original )
      await localStorage.setItem( "auditPayload", payload )
      await dispatch( setAuditModal( { 
          auditFlag: true, 
          title: "Schedule" 
      } ) )
      // await localStorage.setItem( "link", "display" )
      // await localStorage.setItem( "applicationId", record.value )
      // return window.location.reload()
    } } className="cursor-pointer w-auto py-1 px-2 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
      {`Manage Audit Date`}
    </div> )
  )
}

const ProgressField = record => {
  return (
    <div className="flex w-full items-center justify-center">
      <ProgressBar value={record.value}/>
      <div className="text-xs mx-2">
          {`${record.value}%`}
      </div>
    </div>
  )
}

export default function MySchedules( { product } ) {
  const AuditColumns = React.useMemo( () => [
    {
      Header: "#",
      accessor: "recordId"
    },
    {
      Header: "Registered Name of Applicant",
      accessor: "applicant"
    },
    {
      Header: "Email Address",
      accessor: "email_address"
    },
    {
      Header: "Annual Gross Income(UGX)",
      accessor: "annual_income"
    },
    {
      Header: "Scheduled Action",
      accessor: "scheduled_action"
    },
    {
      Header: "Scheduled Date",
      accessor: "scheduled_date"
    },
    {
      Header: "Action",
      accessor: "id",
      Cell: ActionField
    }
   
  ] )
  
  const [ records, setRecords ] = useState( [] )
  const [ loading, setLoading ] = useState( true )
  const dispatch = useDispatch()
  const state = useSelector( state => {
    return {
      auditFlag: state.application.auditModal?.auditFlag,
      title: state.application.paymentModal?.title,
    }
  } )

  React.useEffect( () => {
    if( loading ) {
        fetchApplications()
    }
  },[ loading ])

  const [ suggestedDate, setSuggestedDate ] = useState( false )

  const handleAuditScheduleAction = async (evt) => {
    let selectedScheduleAction = evt.target.value
    if (selectedScheduleAction === "Suggest") {
      setSuggestedDate(true)
    } else{
      setSuggestedDate(false)
    }
  }

  const fetchApplications = async () => {
    try {
      const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication` ) 
      if( response.data ) {
       const results = response.data.map( ( result, index ) => {
        return {
            recordId: `${index+1}`,
            progress: result.progress,
            stage: result.stage,
            applicant: result.trading_name,
            email_address: result.created_by,
            date: moment( result.created_at ).format( "DD MMM, YYYY" ),
            annual_income: result.annual_turnover,
            scheduled_action: result.scheduled_action,
            scheduled_date: result.scheduled_date,
            id: result.id
        }
       } ).filter( record => { 
        return parseInt( record.stage ) === 4  && record.scheduled_action?.toUpperCase() === "PENDING"  && record.email_address?.toLowerCase() === localStorage.getItem( "username" )?.toLowerCase()
      } )

      setRecords( results )
      setLoading( false )

      }
    } catch (error) {
      alert( "Server error occured." )
      setLoading( false )
    }
  }

  const handleClientSchedule = async ( values ) => {
    const payload = JSON.parse( localStorage.getItem( "auditPayload" ) )
    try {
        const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/itcoverify`, {
          id: payload.id,
          scheduled_action: "DATE_CONFIRMED",
          scheduled_date: payload?.scheduled_date,
          audit_client_action: values.action,
          suggested_date: values.suggested_date
          // progress: parseInt( payload.progress ) + 20,
          // stage: parseInt( payload.stage ) + 1,
        //   email_address: record.created_by,
        //   task: "Verified",
        //   created_by: localStorage.getItem( "email" ),
        //   comment: "This application is now Verified",
        //   verification_status: "Completed"
        } )
        if( response.data ) {
          dispatch( setAuditModal( { auditFlag: false, title: "" } ) )
          alert( response.data.message )
          return window.location.reload()
        }
    } catch (error) {}
  }

  let payload = JSON.parse( localStorage.getItem( "auditPayload" ))

  return (
    <Wrapper>
        <div className="flex flex-col h-full">
          <BarStrip />
          <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
            <div className="px-5 py-2 text-sm bg-white">
              {`My Audit Schedules`}
            </div>
            <div className="flex w-full bg-white">
              <Table 
                label="Application Details"
                columns={AuditColumns}
                data={records}
              />
            </div>
          </div>
        </div>
        <ModalComponent title={state.title} open={state.auditFlag} handleOpen={() => dispatch( setAuditModal( { auditFlag: false, title: "" } ) )}>
          {/* <div className="cursor-pointer" >Close</div> */}
          <div className="grid grid-cols-1 w-[700px]">
            <div>
            <Formik initialValues={{
              action: "",
              actioned_by: localStorage.getItem( "username" ),
              comments: "",
              scheduled_date: "",
              suggested_date: ""
              }} onSubmit={handleClientSchedule}>
              { ( { handleSubmit, handleBlur, handleChange, values, isSubmitting } ) => {
                return (
                    <form className="w-full my-2 bg-white" onSubmit={handleSubmit}>
                    
                        <div className="w-full grid grid-cols-2 gap-1">
                          <TextField 
                            name={"scheduled_date"} 
                            value={payload.scheduled_date} 
                            label="Proposed Date" 
                          />
                        </div>

                        <div className="w-full grid grid-cols-2 gap-1">
                          <SelectFieldIcon 
                            name="action"
                            handleChange={evt => {
                              handleChange(evt)
                              handleAuditScheduleAction( evt )
                            }}
                            handleBlur={handleBlur}
                            value={values.action}
                            label="Action"
                            required={true}
                            disabled={false}
                            options={[ 
                                { id: 1, value: "AcceptDate", label: "Confirm Date" },
                                { id: 2, value: "Suggest", label: "Propose New Date" }
                            ]}
                            question="Action" 
                          />
                        </div>
                        <div className="w-full grid grid-cols-2 gap-1">

                          {suggestedDate && <TextFieldIcon 
                                        type="date"
                                        name="suggested_date"
                                        value={values.suggested_date}
                                        handleChange={handleChange}
                                        handleBlur={handleBlur}
                                        label="Suggest Date"
                                        disabled={false}
                                        question={`Suggest Date of Audit`}
                                        required={true} />}

                        </div>

                        <div className="flex items-center">
                          <button onClick={() => dispatch( setAuditModal( { auditFlag: false, title: "" } ) )} className="bg-blue-700 w-20 text-white text-xs my-2 px-2 py-1 mx-2" type="button">
                            {`Cancel`}
                          </button>
                          <button type="submit" className="bg-green-700 w-20 text-white text-xs my-2 px-2 py-1">
                            {`Submit`}
                          </button>
                        </div>
                    </form>
                  )
                }  }
            </Formik>
            </div>
            
          </div>
        </ModalComponent>
    </Wrapper>
  )
}
